import type {RefObject} from 'react'
import {useEffect, useState} from 'react'

// This hook will help detect when a sticky element gets stuck. It requires top: -1px to work correctly.
export const useIsStuck = (ref: RefObject<HTMLDivElement>) => {
  const [isStuck, setIsStuck] = useState(false)

  useEffect(() => {
    const cachedRef = ref.current
    const observer = new IntersectionObserver(([e]) => setIsStuck(e.intersectionRatio < 1), {
      threshold: [1],
    })

    if (cachedRef != null) {
      observer.observe(cachedRef)
    }

    return () => {
      if (cachedRef != null) {
        observer.unobserve(cachedRef)
      }
    }
  }, [ref])

  return isStuck
}
